import * as React from 'react'
import { Image, Text, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import useI18n from '@i18n/useI18n'

import theme from '@theme/Theme'

export const BUTTON_HEIGHT = 80

interface Props {
  count: number
  onClick: () => void
}

const DocumentButton = ({ count, onClick }: Props) => {
  const i18n = useI18n()
  return (
    <ButtonContainer activeOpacity={0.9} onPress={onClick}>
      <LeftContainer>
        <Title>{i18n.t('components.documentButton.title')}</Title>
        <Description>
          {count > 0
            ? i18n.t('components.documentButton.total', { count })
            : i18n.t('components.documentButton.noDocument')}
        </Description>
      </LeftContainer>
      <Icon name="arrow" size={24} color={theme.colors.primary} />
      <BackgroundPicture source={require('@assets/images/documents.png')} resizeMode="contain" />
    </ButtonContainer>
  )
}

export default DocumentButton

const ButtonContainer = styled(TouchableOpacity)`
  background-color: ${(props) => props.theme.colors.background};
  border-radius: 8px;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  height: ${BUTTON_HEIGHT}px;
  overflow: hidden;
`
const LeftContainer = styled(View)`
  flex: 1;
  margin-right: 16px;
`
const Title = styled(Text)`
  ${(props) => props.theme.fonts.Subheadline};
  margin-bottom: 4px;
`
const Description = styled(Text)`
  ${(props) => props.theme.fonts.Footnote};
  color: ${(props) => props.theme.colors.secondaryText};
`
const BackgroundPicture = styled(Image)`
  position: absolute;
  z-index: -1;
  top: -20px;
  right: 5px;
  width: 100px;
  height: 115px;
`
